import React from "react";
export default function Facilities() {
    return (
           <section id="amenities" className="content-section amenities-section">
        <div className="container">
            <h2 className="display-5 fw-bold text-center mb-4 amenities-title">Facilities</h2>
            <div className="row g-3">
                <div className="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div className="amenity-item-compact">
                        <div className="amenity-icon-compact">
                            <i className="fas fa-bed"></i>
                        </div>
                        <h6 className="amenity-title-compact">Spacious & Well Furnished Rooms</h6>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div className="amenity-item-compact">
                        <div className="amenity-icon-compact">
                            <i className="fas fa-tree"></i>
                        </div>
                        <h6 className="amenity-title-compact">Spacious Lawn</h6>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div className="amenity-item-compact">
                        <div className="amenity-icon-compact">
                            <i className="fas fa-utensils"></i>
                        </div>
                        <h6 className="amenity-title-compact">Food Plaza (Fast Food / Veg., Non-veg.)</h6>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div className="amenity-item-compact">
                        <div className="amenity-icon-compact">
                            <i className="fas fa-child"></i>
                        </div>
                        <h6 className="amenity-title-compact">Children's Park & Garden</h6>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div className="amenity-item-compact">
                        <div className="amenity-icon-compact">
                            <i className="fas fa-users"></i>
                        </div>
                        <h6 className="amenity-title-compact">Conference Hall</h6>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div className="amenity-item-compact">
                        <div className="amenity-icon-compact">
                            <i className="fas fa-car"></i>
                        </div>
                        <h6 className="amenity-title-compact">Car on Rent</h6>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div className="amenity-item-compact">
                        <div className="amenity-icon-compact">
                            <i className="fas fa-tshirt"></i>
                        </div>
                        <h6 className="amenity-title-compact">Laundry Facility</h6>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 text-center">
                    <div className="amenity-item-compact">
                        <div className="amenity-icon-compact">
                            <i className="fas fa-tv"></i>
                        </div>
                        <h6 className="amenity-title-compact">Cable TV & Telephones in All Rooms</h6>
                    </div>
                </div>
                
                {/* <div className="swimming-pool-highlight"> */}
                <div className="col-lg-6 col-md-8 col-sm-12 text-center mx-auto">
                    <div className="amenity-item-compact swimming-pool-special">
                        <div className="amenity-icon-compact swimming-pool-icon">
                            <i className="fas fa-swimming-pool"></i>
                        </div>
                        <h6 className="amenity-title-compact swimming-pool-title">Swimming Pool</h6>
                        <div className="swimming-pool-badge">
                            <i className="fas fa-star"></i>
                            <span>Only Hotel in Panhala with Swimming Pool</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
};